export const FILE_URL = 'https://appneurofrequencies.com';
// export const FILE_URL = 'https://neurofrecuenciesapi-production.up.railway.app';
// export const FILE_URL = 'http://127.0.0.1:4040';
// export const FILE_URL = 'http://165.232.133.205';
export const API_URL = `${FILE_URL}/api/v1`;
export const TOKE_NAME = 'nf:auth:token';
